import { createContext, useContext, useState, useEffect } from "react";
import {
  api,
  getAdminToken,
  setAdminToken,
  clearAdminToken,
  getCollabToken,
  setCollabToken,
  clearCollabToken,
} from "@/lib/api";

const AuthCtx = createContext(null);
const COLLAB_INFO_KEY = "spectrum_collab_info";

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [collab, setCollab] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminT = getAdminToken();
    const collabT = getCollabToken();
    if (adminT) {
      api
        .get("/auth/verify")
        .then(() => setRole("admin"))
        .catch(() => clearAdminToken())
        .finally(() => setLoading(false));
    } else if (collabT) {
      api
        .get("/collaborators/me")
        .then((r) => {
          setRole("collaborator");
          setCollab(r.data);
          localStorage.setItem(COLLAB_INFO_KEY, JSON.stringify(r.data));
        })
        .catch(() => {
          clearCollabToken();
          localStorage.removeItem(COLLAB_INFO_KEY);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginAdmin = async (password) => {
    const { data } = await api.post("/auth/login", { password });
    clearCollabToken();
    localStorage.removeItem(COLLAB_INFO_KEY);
    setAdminToken(data.token);
    setRole("admin");
    setCollab(null);
  };

  const loginCollab = async (email, password) => {
    const { data } = await api.post("/collaborators/login", {
      email,
      password,
    });
    clearAdminToken();
    setCollabToken(data.token);
    localStorage.setItem(COLLAB_INFO_KEY, JSON.stringify(data.collaborator));
    setRole("collaborator");
    setCollab(data.collaborator);
  };

  const registerCollab = async (payload) => {
    await api.post("/collaborators/register", payload);
  };

  const logout = () => {
    clearAdminToken();
    clearCollabToken();
    localStorage.removeItem(COLLAB_INFO_KEY);
    setRole(null);
    setCollab(null);
  };

  return (
    <AuthCtx.Provider
      value={{
        role,
        isAdmin: role === "admin",
        isCollab: role === "collaborator",
        collab,
        loading,
        loginAdmin,
        loginCollab,
        registerCollab,
        logout,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
